import { render, staticRenderFns } from "./RemoveSectionButton.vue?vue&type=template&id=703ddcf0&"
import script from "./RemoveSectionButton.vue?vue&type=script&lang=ts&"
export * from "./RemoveSectionButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports